import React from "react";
import { Column, Row, Text, Icon, Divider, Button, Loader } from "@amzn/meridian";
import ThemedTag from "./ThemedTag";
import checkLargeTokens from "@amzn/meridian-tokens/base/icon/check-large";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import closeMediumTokens from "@amzn/meridian-tokens/base/icon/close-medium";
import minusTokens from "@amzn/meridian-tokens/base/icon/minus";
import { InspectionResult } from "src/services/inspectionService";
import { isResultNA } from "src/components/pages/inspection/utils";

export interface ComplianceResultRowProps {
    result: InspectionResult;
    index: number;
    isLast: boolean;
    onClick?: () => void;
}

const ComplianceResultRow: React.FC<ComplianceResultRowProps> = ({ result, index, onClick, isLast }) => {
    const label = `D${index + 1}`;
    const objectLabel = result.objectId || `Object-${index + 1}`;
    const isAnalysisPending = result.aiResult?.toUpperCase() === "PENDING";
    const isNA = isResultNA(result);

    return (
        <Column spacingInset="300 none" spacing="400 none">
            <Row
                alignmentHorizontal="justify"
                alignmentVertical="center"
                spacingInset="200 none"
            >
                <div onClick={onClick}>
                    <Row alignmentVertical="center" spacing="300" >
                        {isAnalysisPending ? (
                            <Loader size="small" type="circular" />
                        ) : isNA ? (
                            <div className="status-circle status-circle--na">
                                <Icon tokens={minusTokens} color="secondary" />
                            </div>
                        ) : (
                            <div
                                className={`status-circle ${result.isCompliant
                                    ? "status-circle--compliant"
                                    : "status-circle--non-compliant"
                                    }`}
                            >
                                {result.isCompliant ? (
                                    <Icon tokens={checkLargeTokens} color="success" />
                                ) : (
                                    <Icon tokens={closeMediumTokens} color="error" />
                                )}
                            </div>
                        )}
                        <Text type="h50" color="secondary">
                            {label}
                        </Text>
                        <Text type="b200" color="secondary">
                            {objectLabel}
                        </Text>
                    </Row>
                </div>
                <Button onClick={onClick} type="icon">
                    <Icon tokens={chevronRightSmallTokens} color="secondary" />
                </Button>
            </Row>
            {!isLast && <Divider />}
        </Column>
    );
};

export default ComplianceResultRow;
